import { Link, useParams } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";

const MODULES = {
  "research-assistant": {
    title: "Research Assistant",
    blurb: "Chat with an AI analyst about any company in the universe — fundamentals, filings and news in plain language.",
  },
  portfolio: {
    title: "Portfolio",
    blurb: "Track positions, cost basis and performance with AI-powered attribution.",
  },
  watchlists: {
    title: "Watchlists",
    blurb: "Save companies, set alert thresholds and monitor your shortlist daily.",
  },
  "risk-tools": {
    title: "Risk Tools",
    blurb: "Drawdown analysis, concentration warnings and volatility screens for your holdings.",
  },
};

export default function ComingSoon() {
  const { slug } = useParams();
  const mod = MODULES[slug] || { title: "Module", blurb: "This module is on the roadmap." };

  return (
    <div className="max-w-xl fade-up" data-testid="coming-soon-page">
      <div className="widget p-10">
        <div className="w-10 h-10 border border-border rounded-sm flex items-center justify-center mb-6">
          <Lock className="w-5 h-5 text-muted-foreground" />
        </div>
        <div className="overline-label mb-2 text-yellow-500">Coming soon</div>
        <h1 className="font-heading font-black tracking-tighter text-4xl text-white mb-4">{mod.title}</h1>
        <p className="text-muted-foreground leading-relaxed mb-8">{mod.blurb}</p>
        <Link to="/" data-testid="back-to-dashboard-link"
          className="inline-flex items-center gap-2 text-sm text-primary hover:underline">
          <ArrowLeft className="w-4 h-4" /> Back to dashboard
        </Link>
      </div>
    </div>
  );
}
